export const APP_VIEW = 'app';
export const ORG_VIEW = 'org';
export const AGENCY_VIEW = 'agency';
//# sourceMappingURL=constants.js.map